import { path } from '@/routes/Routes.helpers';
import { ClothingIF, RawClothingIF } from '@/api/clothingApi/types';
import {
    FIT_ATTRIBUTE_TYPE,
    LOWER_FIT_ATTRIBUTE_TYPE,
} from '@/constants/attributeTypes';

const extractFitFromAttributes = (
    attributeValues: RawClothingIF['attributeValues'],
): string | null => {
    const fitAttribute = attributeValues?.find(
        (values) =>
            values.categoryAttribute?.type === FIT_ATTRIBUTE_TYPE ||
            values.categoryAttribute?.type === LOWER_FIT_ATTRIBUTE_TYPE,
    );

    return fitAttribute?.value ?? null;
};

export const normalizeClothing = (raw: RawClothingIF): ClothingIF => ({
    ...raw,
    fit: raw.fit ?? extractFitFromAttributes(raw.attributeValues),
    path: path('wardrobeClothingSingle', raw.guid),
});

export const normalizeClothingList = (raw: RawClothingIF[]): ClothingIF[] =>
    raw.map((item) => normalizeClothing(item));
